export const FAILED = 'Login/failed';
export const LOADING = 'Login/loading';

export const RECAPTCHA_KEY = '6LcR4mkbAAAAAA6KdmJb9Tg3l3JSg6hkRrVYOU9S';
